export default "__VITE_ASSET__DYaj054r__"